import { render, staticRenderFns } from "./MoveToFixedConfirmationPopup.vue?vue&type=template&id=1bc8a708&scoped=true&"
import script from "./MoveToFixedConfirmationPopup.vue?vue&type=script&lang=js&"
export * from "./MoveToFixedConfirmationPopup.vue?vue&type=script&lang=js&"
import style0 from "./MoveToFixedConfirmationPopup.vue?vue&type=style&index=0&id=1bc8a708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc8a708",
  null
  
)

export default component.exports